// extracted by mini-css-extract-plugin
export default {"MainContainer":"Profile_MainContainer__1RgwT"};